// src/hooks/termOfPayments/useGetTermOfPayment.js
import { useQuery } from "@tanstack/react-query";
import { getTermOfPayment } from "../../api/apiTermOfPayments";

const useGetTermOfPayment = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["termOfPayment", id],
        queryFn: () => getTermOfPayment(id),
        enabled: !!id,
    });

    const termOfPayment = data?.data || null;

    return { termOfPayment, isLoading, error, refetch };
};

export default useGetTermOfPayment;